import {
    Locale, createDropdown, Plugin, ButtonView,
    ListSeparatorView,
} from 'ckeditor5'
import i18n from 'i18next'
import utils from '../utils'

export default class MainMergeFields extends Plugin {
    constructor(editor) {
        super(editor)
        this.editor = editor
        this.locales = editor.config.get('custom.locales')
        this.clientLocales = editor.config.get('custom.clientLocales')
        this.gatewayUrl = editor.config.get('custom.gatewayUrl')
        this.mergeFields = editor.config.get('custom.mergeFields')
        this.toolbar = editor.config.get('custom.toolbar')
    }

    triggerOnBlur = () => {
        const { view } = this.editor.editing
        if (view) {
            view.focus()
            view.document.fire('blur')
        }
    }

    createSurveyLinkButton = (locale, loc) => {
        const linkText = loc
            ? `${i18n.t('merge_field_main_surveylink')} ${this.clientLocales[loc]}`
            : i18n.t('sch_email_insert_survey_link_text')
        const buttonView = new ButtonView(locale)

        buttonView.set({
            label: linkText,
            withText: true,
        })

        buttonView.on('execute', () => {
            const uriPattern = new RegExp('http://[a-z0-9]+.explori.com/survey\/[0-9]+\/emailschedule\/[0-9]+\/', 'g')
            const uriPattern2 = new RegExp('http://[a-z0-9]+.explori.com/survey\/[0-9]+\/emailschedule\/', 'g')
            // replace cases when merge fields are added into span tags and formatting is lost
            const spanPattern = /(<\/span>)(\[\w*\])(<span[^>]*>)/gi
            let value = `<a href="[surveylink${loc ? ` lang=${loc}` : ''}]">Survey Link</a>`
            value = value.replace(uriPattern, '').replace(uriPattern2, '')
            value = value.replace(spanPattern, '$2')

            const viewFragment = this.editor.data.processor.toView(value)
            const modelFragment = this.editor.data.toModel(viewFragment)
            this.editor.model.insertContent(modelFragment)
            this.triggerOnBlur()
        })

        return buttonView
    }

    init() {
        this.editor.ui.componentFactory.add('mainMergefield', () => {
            const locale = new Locale()
            const listDropdown = createDropdown(locale)
            listDropdown.set({ panelPosition: 'se' })
            listDropdown.panelView.set({ maxWidth: '400px' })
            listDropdown.buttonView.set({
                label: i18n.t('merge_field_main_label'),
                withText: true,
                tooltip: i18n.t('merge_field_main_tooltip'),
                icon: utils.infoIcon,
            })
            const collection = listDropdown.panelView.children

            if (this.toolbar === 'emailSchedule') {
                if (this.locales.length) {
                    this.locales.forEach((loc) => {
                        collection.add(this.createSurveyLinkButton(locale, loc))
                    })
                } else {
                    collection.add(this.createSurveyLinkButton(locale))
                }

                collection.add(new ListSeparatorView(locale))

                const optOut = new ButtonView(locale)

                optOut.set({
                    label: i18n.t('merge_field_main_optout'),
                    withText: true,
                })

                optOut.on('execute', () => {
                    const value = `<a href="${this.gatewayUrl}/survey/[surveyId]/[UUID]/optout/">Opt-out</a>`
                    const viewFragment = this.editor.data.processor.toView(value)
                    const modelFragment = this.editor.data.toModel(viewFragment)
                    this.editor.model.insertContent(modelFragment)
                    this.triggerOnBlur()
                })

                collection.add(optOut)

                collection.add(new ListSeparatorView(locale))
            }

            this.mergeFields.filter((mergeField) => mergeField.type !== 'pipeAnswer').forEach((mergeField) => {
                const title = mergeField.title ? i18n.t(mergeField.title) : i18n.t(`merge_field_${mergeField.code}`)

                const buttonView = new ButtonView(locale)

                buttonView.set({
                    label: title,
                    withText: true,
                })

                buttonView.on('execute', () => {
                    const value = `[${mergeField.code}]`
                    const viewFragment = this.editor.data.processor.toView(value)
                    const modelFragment = this.editor.data.toModel(viewFragment)
                    this.editor.model.insertContent(modelFragment)
                    this.triggerOnBlur()
                })

                collection.add(buttonView)
            })

            // room to add further mergefields or tags below

            return listDropdown
        })
    }
}
